export default {
  title: 'Tilausportaali',
  form: {
    username: {
      placeholder: 'Käyttäjänimi',
    },
    password: {
      placeholder: 'Salasana',
    },
  },
  buttons: {
    submit: 'Kirjaudu sisään',
  },
  toasts: {
    auth_token_invalid: 'Annettu tunnistetoken on virheellinen, kirjaudu sisään käyttäjätunnuksilla',
    credentials_invalid: 'Väärä käyttäjänimi tai salasana',
  },
};
